import { Box, Stack, Typography } from "@mui/material";
import {
    ConstructorViewInfoStatus,
    PrintProjectDetailDto,
    ProjectRelatedEntitiesContainerDto,
} from "../../../api/psc";
import { getAccessErrorMessageOrNull } from "../../../constants/SubscriptionConstants";
import { projectPrintItemStyle } from "../../../styles/ProjectDefaultStyles";
import {
    getCurrentDate,
    getPhaseLastUpdateDateDiff,
    toJalaliDate,
} from "../../../utils/date";

// updated
export default function (props: {
    project: PrintProjectDetailDto;
    baseInfo: ProjectRelatedEntitiesContainerDto;
}) {
    if (
        props.project.constructorViewInfo.status ===
        ConstructorViewInfoStatus.ACCESS_DENIED
    ) {
        const accessError = getAccessErrorMessageOrNull(
            props.project.constructorViewInfo.status
        );

        if (accessError) {
            return (
                <Stack
                    sx={projectPrintItemStyle}
                    alignItems="center"
                >
                    <Typography
                        sx={{ p: 4 }}
                        textAlign="center"
                    >
                        {accessError}
                    </Typography>
                </Stack>
            );
        }
    }

    const city = props.baseInfo.cities.find(
        (c) => c.id === props.project.cityId
    );
    const region = city?.regions.find((c) => c.id === props.project.regionId);

    const phase = props.baseInfo.phaseList.find(
        (c) => c.id === props.project.phaseId
    );
    const structureType = props.baseInfo.structureTypes.find(
        (c) => c.id === props.project.structureTypeId
    );
    const usageType = props.baseInfo.usageTypes.find(
        (c) => c.id === props.project.usageTypeId
    );

    const row = (
        title: string,
        value: string,
        bold: boolean = false
    ): JSX.Element => {
        return (
            <Box>
                <Typography
                    fontSize="inherit"
                    color="text.secondary"
                    component="span"
                >
                    {title}:{" "}
                </Typography>
                <Typography
                    fontSize="inherit"
                    component="span"
                    fontWeight={bold ? "bolder" : "normal"}
                >
                    {value}
                </Typography>
            </Box>
        );
    };

    return (
        <Stack
            spacing={1}
            sx={projectPrintItemStyle}
        >
            <Stack
                spacing={1}
                direction="row"
                justifyContent="space-between"
            >
                {row("شناسه", props.project.hashId)}

                {row(
                    "مرحله",
                    phase.title +
                        " - از " +
                        getPhaseLastUpdateDateDiff(
                            props.project.phaseLastUpdateDate
                        ).description +
                        " پیش"
                )}

                {row("نوع سازه", structureType.title)}

                {row("نوع کاربری", usageType.title)}

                {region.title}
            </Stack>

            <Stack
                spacing={1}
                direction="row"
                justifyContent="space-between"
            >
                {row("کارفرما", props.project.receptor || "بدون کارفرما")}

                {props.project.constructorViewInfo.status ==
                ConstructorViewInfoStatus.NO_ERROR ? (
                    <>
                        {row(
                            "نام صاحب شماره",
                            props.project.constructorViewInfo?.constructor
                                ?.name || "بدون سازنده"
                        )}

                        {row(
                            "شماره تلفن",
                            props.project.constructorViewInfo?.constructor?.mobileNumbers?.join(
                                ","
                            ) || "بدون شماره",
                            true
                        )}
                    </>
                ) : (
                    <>
                        {getAccessErrorMessageOrNull(
                            props.project.constructorViewInfo.status
                        )}
                    </>
                )}
            </Stack>

            {row("آدرس", props.project.constructorViewInfo?.address)}

            <Stack
                spacing={1}
                direction="row"
                justifyContent="space-between"
            >
                {row("زیر بنا", props.project.residentialArea.toString())}

                {row("متراژ زمین", props.project.groundArea.toString())}

                {row("طبقات", props.project.floors.toString())}

                {row("طبقات منفی", props.project.subFloors.toString())}

                {row("تعداد واحد", props.project.units.toString())}
            </Stack>

            <Stack
                spacing={1}
                direction="row"
                justifyContent="space-between"
            >
                {row("تاریخ مشاهده", toJalaliDate(props.project.visitDate))}

                {row(
                    "تاریخ به روز رسانی",
                    toJalaliDate(props.project.lastUpdateDate)
                )}

                {row("تاریخ چاپ", toJalaliDate(getCurrentDate()))}
            </Stack>

            <Typography
                fontSize="smaller"
                color="text.secondary"
                flexGrow={1}
                sx={{ textAlign: "center" }}
            >
                اطلاعات فوق از تاریخ ارائه به مدت 10 روز دارای اعتبار است.
            </Typography>
        </Stack>
    );
}
